import React from "react";
import { useNavigate } from "react-router-dom";

const Newsletter = () => {
  const navigate = useNavigate();
  return (
    <>
      <section>
        <div className="max-w-6xl mx-auto my-16 ">
          <div className="pb-12 md:pb-20">
            <div
              className="relative bg-green-600 rounded-3xl py-10 px-8 md:py-16 md:px-12 shadow-2xl overflow-hidden"
              data-aos="zoom-y-out"
            >
              <div className="relative flex flex-col lg:flex-row justify-between items-center">
                <div className="text-center lg:text-left lg:max-w-xl">
                  <h3 className="md:text-3xl font-bold  text-white text-lg mb-2">
                    Lets get connected and start finding your dream job.
                  </h3>
                </div>
                <button
                  className="btn-sm text-black bg-white hover:bg-white ml-3 px-5 py-3 rounded-lg cursor-pointer"
                  onClick={() => navigate("/register")}
                >
                  <span>Create an account</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Newsletter;
